module.exports = __webpack_public_path__ + "static/media/pigo_3.95938ebb.png";